import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { InlineListEdit } from '@/components/recipe/inline-list-edit'

interface RecipeInstructionsCardProps {
  instructions: string[]
  isInlineEditMode: boolean
  onInlineUpdate: (field: string, value: unknown) => Promise<boolean>
}

export function RecipeInstructionsCard({
  instructions,
  isInlineEditMode,
  onInlineUpdate,
}: RecipeInstructionsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Bereidingswijze</CardTitle>
      </CardHeader>
      <CardContent>
        {isInlineEditMode ? (
          <InlineListEdit
            items={instructions}
            onSave={(items) => onInlineUpdate('instructions', items)}
            placeholder="Voeg stap toe..."
            addButtonText="Stap toevoegen"
            itemType="instruction"
          />
        ) : (
          <ol className="space-y-4">
            {instructions.map((instruction, index) => (
              <li key={index} className="flex items-start">
                <span className="mr-4 mt-1 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-sm font-medium text-white">
                  {index + 1}
                </span>
                <p className="leading-relaxed text-gray-700">{instruction}</p>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  )
}
